import React from 'react';
import { Link } from 'react-router-dom';

const Compliance = () => {
    return (
        <div className="bg-gray-50 pt-24 pb-16 px-6 md:px-20">
            <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-extrabold text-[#0c24da] mb-4">Compliance & Government Approvals</h1>
                    <h2 className="text-2xl font-semibold text-gray-700">Reliable Compliance, Licensing & Regulatory Support</h2>
                    <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                        Keeping your business compliant with legal and regulatory requirements is essential for long-term success. We handle your documentation, filings, and renewals so you can focus on growth.
                    </p>
                </div>

                {/* Services Grid */}
                <div className="bg-white p-10 rounded-3xl shadow-lg mb-16 border-t-4 border-[#0c24da]">
                    <h3 className="text-3xl font-bold mb-8 text-center">Our Compliance Services</h3>
                    <div className="grid md:grid-cols-2 gap-6">
                        {[
                            "Business License & Permit Assistance",
                            "Government Registrations",
                            "Regulatory Compliance Support",
                            "Annual Compliance Filing",
                            "License Renewals & Updates",
                            "Business Registration Modifications",
                            "Documentation Preparation & Verification",
                            "Statutory Filing Assistance",
                            "Corporate Compliance Management",
                            "Business Advisory & Regulatory Guidance"
                        ].map((service, i) => (
                            <div key={i} className="flex items-center bg-gray-50 p-4 rounded-xl border border-gray-200">
                                <span className="text-[#f15a24] mr-3 font-bold">●</span>
                                <span className="font-medium text-gray-700">{service}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Why Choose Us */}
                <div className="bg-white p-10 rounded-3xl shadow-lg border-l-8 border-[#f15a24] mb-16">
                    <h3 className="text-3xl font-bold mb-6">Why Choose Rajkuruma?</h3>
                    <div className="grid md:grid-cols-2 gap-4 text-gray-700">
                        {[
                            "Experienced Compliance Consultants",
                            "Fast & Accurate Documentation",
                            "Transparent & Hassle-Free Process",
                            "Timely Filing & License Renewals",
                            "End-to-End Government Approval Support",
                            "Reliable Ongoing Compliance Assistance"
                        ].map((item, i) => (
                            <p key={i} className="flex items-center font-medium">✅ {item}</p>
                        ))}
                    </div>
                </div>

                {/* Final CTA */}
                <div className="text-center bg-[#1a2b4d] p-12 rounded-3xl text-white">
                    <h3 className="text-3xl font-bold mb-4">Stay Compliant, Stay Secure</h3>
                    <p className="mb-8">Get expert guidance for all your regulatory and licensing needs.</p>
                    <Link to="/enquiry" className="bg-[#f15a24] hover:bg-[#d44d18] px-10 py-4 font-bold rounded-full text-lg transition">BOOK CONSULTATION →</Link>
                </div>
            </div>
        </div>
    );
};

export default Compliance;